import { render, staticRenderFns } from "./trd.vue?vue&type=template&id=67839e50&"
import script from "./trd.vue?vue&type=script&lang=js&"
export * from "./trd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports